import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import './FormStylePatient.css';
import { useTenant } from '../context/TenantContext';
import { toast } from 'react-toastify';
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from 'firebase/auth';

const AddUserForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    role: '',
    email: '',
    phone: ''
  });
  const { tenantId, loading } = useTenant();

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!tenantId) {
    alert("Tenant ID not loaded. Please login again.");
    return;
  }

  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      alert("You must be logged in to add a user.");
      return;
    }

    const formattedPhone = formData.phone.startsWith("+91")
      ? formData.phone
      : `+91${formData.phone}`;

    const newUser = {
      name: formData.name,
      email: formData.email,
      phone: formattedPhone,
      role: formData.role,
      tenantId,
      createdAt: Timestamp.now(),
    };

    // 1. Add to "users" collection
    await addDoc(collection(db, "users"), newUser);

    // 2. Also add to "doctors" collection if role is Doctor
    if (formData.role === 'Doctor') {
      await addDoc(collection(db, "doctors"), newUser);
    }

    toast.success("User added successfully!");

    // 3. Reset form
    setFormData({ name: '', role: '', email: '', phone: '' });

  } catch (error) {
    console.error("Error adding user:", error);
    toast.error("Failed to add user");
  }
};


  return (
    <div className="form-container">
      <h2>Add User</h2>
      <form onSubmit={handleSubmit}>
        <label>Name:</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder='Enter name' required />

        <label>Role:</label>
        <select name="role" value={formData.role} onChange={handleChange} required>
          <option value="">Select Role</option>
          <option value="Receptionist">Receptionist</option>
          <option value="Doctor">Doctor</option>
          <option value="Other">Other</option>
        </select>

        <label>Email:</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder='Enter valid email'/>
        <label>Phone:</label>
        <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter 10-digit number"
          maxLength={10} required />

        <button type="submit">Add User</button>
      </form>
    </div>
  );
};

export default AddUserForm;






/*

const handleSubmit = async (e) => {
  e.preventDefault();

  const functions = getFunctions();

  const inviteUser = httpsCallable(functions, "inviteUser");

  try {
    // Format phone number
    let formattedPhone = formData.phone.trim();
    if (!formattedPhone.startsWith('+91')) {
      formattedPhone = '+91' + formattedPhone.replace(/^0+/, '');
    }

    // Submit to Firestore
    await addDoc(collection(db, 'users'), {
      name: formData.name,
      role: formData.role,
      email: formData.email,
      phone: formattedPhone,
      tenantId,
      createdAt: Timestamp.now()
    });

    alert('User added successfully!');
    setFormData({
      name: '',
      role: '',
      email: '',
      phone: ''
    });
  } catch (error) {
    console.error('Error adding user:', error);
    alert('Failed to add User.');
  }
};

*/